import React from 'react';
import { Button } from './ui/button';
import { openTawktrikChat } from '../utils/chatUtils';

const AmazonSection = ({ onOpenModal }) => {
  return (
    <section className="py-20 bg-gradient-to-br from-[#2B0A12] via-[#3D1C24] to-[#2B0A12]">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-[#F1F1F1] mb-6">
          Amazon Brand Registry Assistance
        </h2>
        <p className="text-lg text-gray-300 mb-8 max-w-3xl mx-auto leading-relaxed">
          Protect your Amazon brand from counterfeiters and unauthorized sellers with our expert trademark registration and Brand Registry enrollment services.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            size="lg"
            onClick={() => onOpenModal && onOpenModal('Start Trademark Registration - Amazon Section')}
            className="bg-[#FFB400] hover:bg-[#e5a200] text-[#2B0A12] font-semibold px-8 py-6 rounded-lg shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105"
          >
            Start Trademark Registration
          </Button>
          <Button
            size="lg"
            variant="outline"
            onClick={openTawktrikChat}
            className="border-2 border-[#F1F1F1] text-[#F1F1F1] hover:bg-white hover:text-[#2B0A12] font-semibold px-8 py-6 rounded-lg transition-all duration-300 hover:scale-105"
          >
            Discuss with Attorney
          </Button>
        </div>
      </div>
    </section>
  );
};

export default AmazonSection;